// Shim window.storage (used by the original KnowMeno App) to localStorage
// so the dropped-in component works without modification.
declare global {
  interface Window {
    storage: {
      get: (key: string) => Promise<{ value: string } | null>;
      set: (key: string, value: string) => Promise<void>;
      delete: (key: string) => Promise<void>;
    };
  }
}

export function installStorageShim() {
  if (typeof window === "undefined") return;
  if ((window as any).storage) return;
  window.storage = {
    async get(key: string) {
      const v = window.localStorage.getItem(key);
      return v == null ? null : { value: v };
    },
    async set(key: string, value: string) {
      window.localStorage.setItem(key, value);
      // Notify same-tab listeners (native 'storage' event only fires across tabs)
      window.dispatchEvent(new CustomEvent("menoiq:storage", { detail: { key } }));
    },
    async delete(key: string) {
      window.localStorage.removeItem(key);
      window.dispatchEvent(new CustomEvent("menoiq:storage", { detail: { key } }));
    },
  };
}
